import { EnquiryHeaderItem } from "./enquiry.model";

export class ItemsPricesFromXlsx{
    items?: ItemPriceImport[];
}

export class ItemPriceImport {
    item?: EnquiryHeaderItem
    validations?: {
        actualMarginValidation?: ValidationDetail;
        finalPriceValidation?: ValidationDetail;
        negotiationMarginValidation?: ValidationDetail;
        agentFeeValidation?: ValidationDetail;
        extraCostsValidation?: { [id: number]: ValidationDetail };
        extraLeadTimeValidation?: ValidationDetail
    };
}

export class ValidationDetail {
    message?: string;
    isValid?: boolean;
}
